import { rectangleUserIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const UserCards = createIcon({
  displayName: 'UserCards',
  paths: [
    'M170.667 170.667h597.333c0-47.104-38.229-85.333-85.333-85.333h-512c-47.104 0-85.333 38.229-85.333 85.333v512c0 47.104 38.229 85.333 85.333 85.333v-597.333zM341.333 256c-47.104 0-85.333 38.229-85.333 85.333v512c0 47.104 38.229 85.333 85.333 85.333h512c47.104 0 85.333-38.229 85.333-85.333v-512c0-47.104-38.229-85.333-85.333-85.333h-512zM341.333 853.333v-512h512v512h-512zM576.154 597.333c-82.56 0-149.504 66.901-149.504 149.461 0 11.733 9.515 21.205 21.205 21.205h298.965c11.691 0 21.163-9.472 21.163-21.205 0-82.56-66.901-149.461-149.461-149.461h-42.368zM597.333 426.667c47.104 0 85.333 38.229 85.333 85.333s-38.229 85.333-85.333 85.333c-47.104 0-85.333-38.229-85.333-85.333s38.229-85.333 85.333-85.333z'
  ],
  canvasPaths: canvasIconPaths(rectangleUserIcon)
})
